"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslationsFromNamespace = void 0;
var _react = require("react");
var _reactIntl = require("react-intl");
var _translationsNamespaceContext = require("../../TranslationsNamespaceProvider/translationsNamespaceContext");
var _translationsContext = require("../translationsContext");
/**
 * Represents the return type of formatFunction from useTranslationsFromNamespace hook.
 * @param key Translations key which is part of namespace translations
 * @param values Values to be interpolated into the translated message
 * @typeParam T The type of translations.
 */

/**
 * Represents the return type of useTranslations hook along with a formatting function.
 * @typeParam T The type of translations.
 */

/**
 * A custom hook to access translations and a formatting function.
 *
 * @typeParam T The type of translations.
 * @returns The translations and formatting function.
 */
const useTranslationsFromNamespace = () => {
  const {
    translationsWithNamespaces,
    defaultTranslationsWithNamespaces
  } = (0, _react.useContext)(_translationsContext.translationsContext);
  const {
    namespace
  } = (0, _react.useContext)(_translationsNamespaceContext.translationsNamespaceContext);
  const {
    formatMessage: f
  } = (0, _reactIntl.useIntl)();
  return (0, _react.useMemo)(() => {
    const formatMessage = (key, ...args) => f({
      id: `${namespace}:${String(key)}`
    }, args[0]);
    const translations = translationsWithNamespaces ? translationsWithNamespaces[namespace] : defaultTranslationsWithNamespaces[namespace];
    return {
      translations,
      formatMessage
    };
  }, [f, namespace, translationsWithNamespaces, defaultTranslationsWithNamespaces]);
};
exports.useTranslationsFromNamespace = useTranslationsFromNamespace;
//# sourceMappingURL=useTranslationsFromNamespace.js.map